export const API_URL = {
    // baseURL: "http://13.39.178.227:6101/api/v1/",
    //baseURL: "http://68.178.166.6:6101/api/v1/",
    baseURL: window._env_?.BASE_URL || "http://13.39.178.227:6101/api/v1/",
    fileURL: window._env_?.FILE_URL || "http://68.178.166.6:8080",
    adminAuth: {
        login: "admin/adminLogin",
        Forgetpassword: "admin/forgotPassword",
        resetpassword: "admin/resetPassword",
        logout: "admin/logout",
        changePassword: "admin/changePassword",
        fileUpload: "admin/uploadFile",
        adminById: "admin/getAdminByUserId",
        UpdateAdmin: "admin/updateProfile",
    },
    AdminRole: {
        getRole: "admin/role/get_all_role",
        addRole: "admin/role/add_role",
        getModule: "admin/module/get_all_module",
        blockStaus: "admin/role/blockRole",
        getRoleById: "admin/role/findRoleById",
        getAllAdmin: "admin/getAllAdmin",
        blockAdmin: "admin/block_admin",
        addAdmin: "admin/addAdmin",
    },

    AssementManagement: {
        modelTable: "/assessment/model/getAllModel?pageIndex=0&pageSize=10",
    },
    ModelManagement: {
        modelList: "/assessment/model/getAllModel",
        addModel: "/assessment/model/addModel",
        blockModel: "/assessment/model/blockModel",
        modellistwithallchild: "/assessment/model/getAllModelDimensionSubDimension",
        deleteModal: "/assessment/model/softDeleteModel"
    },
    DimensionManagement: {
        dimensionList: "/assessment/dimension/getAllDimension",
        adddimension: "/assessment/dimension/addDimension",
        blockDimension: "/assessment/dimension/blockDimension",
        getAllModels: "/assessment/dimension/getAllModels",
        deleteDimension: "assessment/dimension/softDeleteDimension"
    },
    SubDimensionManagement: {
        subdimensionList: "/assessment/sub_dimension/getAllSubDimension",
        addSubDimension: "/assessment/sub_dimension/addSubDimension",
        blocksubDimension: "/assessment/sub_dimension/blockSubDimension",
        getAllDimensionByModelId: "/assessment/sub_dimension/getAllDimensionByModelId",
        subdimensionById: "/assessment/criteria/getAllSubDimensionByDimensionId",
        deleteSubDimension: "/assessment/sub_dimension/softDeleteSubDimension"
    },
    CriteriaManagement: {
        CriteriaList: "/assessment/criteria/getAllCriteria",
        addCriteria: "/assessment/criteria/addCriteria",
        blockCriteria: "/assessment/criteria/blockCriteria",
        getCriteriaByModelId: "/assessment/criteria/getCriteriaByModelId",
        BulkUpload: "/assessment/criteria/bulkUploading",
        deleteCriteria: "/assessment/criteria/deleteCriteria"
    },
    BulkUpload: {
        allBulkUpload: "/assessment/criteria/modelBulkUploading",
    },
    Assessors: {
        getAllCompanyAssessors: "/user/employee/getAllCompanyAssessors",
        addUpdateCompanyAssessor: "/user/employee/addUpdateCompanyAssessor",
        getAssessors: "/admin/getAssessors",
        companyAssessorDeactivate: "/user/employee/companyAssessorDeactivate",
        deleteCompanyAssessorById: "/user/employee/deleteCompanyAssessorById",
    },
    CustomerManagement: {
        addEmployee: "/user/employee/addEmployee",
        getEmployeeById: "/user/employee/getEmployeeById",
        addCompany: "/user/company/addCompany",
        getAllCompany: "/user/company/getAllCompany",
        getCompanyById: "/user/company/getCompanyById",
        getAllEmployee: "/user/employee/getAllEmployee",
        activeInactiveCompany: "/user/company/activeInactiveCompany",
        activeInactiveEmployee: "/user/employee/activeInactiveEmployee",
        getAllCompanies: "/user/company/getCompanies",
        individualResult: "/user/employee/individualResult",
        individualResultValidate: "/user/employee/validate",
        getAllOnsiteEmp: "/user/employee/getAllOnSiteEmployees",
        hirarchy: "/user/employee/allHierarchys",
        department: "/user/employee/allDepartment",
        employeeBulkUpload: "user/employee/employeeBulkUploading",
        getAllCampaignByCompanyId: "/user/employee/getAllCampaignByCompanyId",
        getAllEmployeesByCampaignId: "/user/employee/getAllEmployeesByCampaignId",
        deleteCampaign: "/user/employee/deleteCampaign",
    },
    country: {
        getAllCountry: "/admin/country/getAllCountry",
    },

    ChartData: {
        OverallParticipationId: "user/employee/overallParticipation",
        dimensionParticipationId: "/user/employee/dimensionParticipation",
        radialDimensionDetailsId: "/user/employee/radialDimensionDetails",
        dmmSubdimensionsResultsId: "/user/employee/dmmSubdimensionsResults",
        overallParticipationDivisionId: "/user/employee/overallParticipationDivision",
        overallParticipationJobLevelId: "/user/employee/overallParticipationJobLevel",
        overAllHeatMap: "/user/employee/overallHeatmap",
        dimensionCurrentId: "/user/employee/dimensionCurrent",
        dimensionFutureId: "/user/employee/dimensionFuture",
        customerMaturityLine: "/user/employee/maturityLine",
        divisionLevelHeatmap: "/user/employee/demographic_dashboard_division_level",
        dimessionDeepDives: "/user/employee/dimensionDeepDives",
        dimensionMaturityLineOverallVersusBenchmarkRecordsId: "/user/employee/dimensionMaturityLineOverallVersusBenchmarkRecords",
        subDimensionMaturityLineOverallVersusBenchmarkId: "/user/employee/subDimensionMaturityLineOverallVersusBenchmark",
        getDashboardDetails: "/user/employee/getDashboardDetails",
        getDashboardDetailsGraph: "/user/employee/getDashboardDetailsGraph",
        addRemark: "/user/employee/addRemark",
        getDimensionsByCampaignId: "/user/employee/getDimensionsByCampaignId"
    },
    AssigmentAssesment: {
        getAssismentEmployee: "/user/employee/getAllAssignEmployees",
        addAssisment: "/user/employee/createUpdateCampaign",
        getAssismentEmployeeByCompanyId: "/user/employee/getAllAssignEmployeesByCompanyId",
        getAllAssignEmployeesByCampaignId: "/user/employee/getAllAssignEmployeesByCampaignId",
        resendAssessmentLink: "/user/employee/resendAssessmentLink",
        EmployeeResult: "/user/employee/employeeResult"
    },
    userLogin: {
        login: "user/employee/sendEmailOtp",
        verifyOtp: "user/employee/verifyOtp",
        logOut: "/user/employee/logoutEmployee",
        userDetails: "user/employee/getEmployeeById"
    },
    userAssesment: {
        addAssesment: "/user/employee/submitUserAssessment",
        userAssesmentOption: "/user/employee/getOptionsByCriteriaId",
        allAnswer: "/user/employee/getOptionsByEmployeeId",
        clearResponce: "/user/employee/clearResponse",
        userAssesmentByCriteraIdNew: "/assessment/criteria/getModelHierarchyByEmployee",
        campaignByEmployeeId: "/user/employee/getAllEmployeeCampaignByEmployeesId"
    },
    notification: {
        getAllNotification: "/user/employee/getAllNotification",
        changeNotificationStatus: "/user/employee/changeSeenStatus",
    },
    orgnigationwiseResult: {
        companywiesuserResult: "/user/employee/companyResults"
    }

};



